import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { viewBox: "0 0 18 19" }

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M13 .5a5 5 0 0 1 5 5v8a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5v-8a5 5 0 0 1 5-5h8zm0 1H5a4 4 0 0 0-3.995 3.8L1 5.5v8a4 4 0 0 0 3.8 3.995l.2.005h8a4 4 0 0 0 3.995-3.8l.005-.2v-8a4 4 0 0 0-3.8-3.995L13 1.5zM9 5a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9zm0 1a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7zm5-2.5a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" }, null, -1)
  ])))
}
export default { render: render }